import { Suspense } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAppConfig } from '@/lib/hooks/useAppConfig';
import { LoginForm } from './LoginForm';

function SignUpContent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirect = searchParams.get('redirect');
  const priceId = searchParams.get('priceId');
  const inviteId = searchParams.get('inviteId');
  const { waitingListMode, isLoading: configLoading } = useAppConfig();

  if (configLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-background">
        <Loader2 className="animate-spin h-8 w-8 text-muted-foreground" />
      </div>
    );
  }

  if (waitingListMode) {
    navigate('/', { replace: true });
    return null;
  }

  return (
    <LoginForm
      mode="signup"
      redirect={redirect}
      priceId={priceId}
      inviteId={inviteId}
    />
  );
}

export default function SignUpPage() {
  return (
    <Suspense fallback={<div className="h-screen flex items-center justify-center">Loading...</div>}>
      <SignUpContent />
    </Suspense>
  );
}
